<template lang='pug'>
md-card(
    style='padding: 40px; margin: 0; width: fit-content; position: static;')
    md-card-content
      div(style='text-align: center; display: flex; flex-direction: column; align-items: center;')
        h4.title(style='display: inline; font-weight: 400; font-size: 24px; color: #232323; line-height: 16.94px;')
          | {{ workspace.name }}
        button.md-button(
          class='access-workspace',
          @click='goToWorkspace(workspace)'
        )
          | {{ $t("importWorkspace.selectWorkspace") }}
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'WorkspacesCard',
  props: {
    workspace: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapFields('selectedAssistant', ['workspaceActiveId'])
  },
  methods: {
    goToWorkspace (workspace) {
      this.workspaceActiveId = workspace.id
      this.$router.push('/selecionar-versao-workspace')
    }
  }
}
</script>

<style scoped>
.access-workspace {
  background-color: #6BA652 !important;
  color: #fff !important;
  padding: 10px 16px;
  margin-top: 20px;
  font-weight: 400;
  font-size: 14px;
  width: 100%;
  border-radius: 6px;

  &:hover, &:focus, &:active, &:active:focus {
      background-color: #4C8342 !important;
  }
}

@media (max-width: 600px) {
  md-card {
    width: 100% !important;
  }
  h4.title {
    font-size: 18px !important;
    word-break: break-all;
  }
}

</style>
